'use client'
import { Excanary } from '@/payload-types'
import Link from 'next/link'
import Image from 'next/image'

export const ExCanaryLobbyPage = ({ data }: { data: Excanary[] }) => {
  return (
    <>
      <div className="ml-2 mb-6 mr-2">
        <h1 className="text-3xl font-bold mr-4 mb-2">Ex-Canary</h1>

        <p>
          Ex-Canary features individuals who were formerly investigated and featured on Canary
          Mission but have since rejected the latent anti-Semitism on the far-right, far-left, and
          among anti-Israel organizations and activists.
        </p>
        <br />

        <p>
          These individuals have displayed the intellectual honesty to acknowledge the problem of
          anti-Semitism within anti-Israel organizations such as &nbsp;
          <strong>Students for Justice in Palestine (SJP)</strong>, &nbsp;
          <strong>Jewish Voice for Peace (JVP)</strong>, and the &nbsp;
          <strong>Boycott, Divestment, Sanctions (BDS)</strong> movement. They have shown moral
          courage to recognize their earlier mistakes – despite social pressure from their peers. We
          commend these individuals for their strength of character in embracing tolerance and
          coexistence.
        </p>
        <br />
        <p className="note">
          Due to a fear of harassment, Ex-Canaries&apos; identities may be removed.
        </p>
        <br />

        <p>
          For inquiries about becoming an Ex-Canary, please visit the{' '}
          <Link className="text-colorLink no-underline" href="/contact_us">
            Contact Us
          </Link>{' '}
          page.
        </p>
      </div>

      <div className="flex flex-wrap justify-center -ml-5">
        {data.length === 0 ? (
          <div className="flex justify-center items-center h-full w-full">
            <h4 className="text-2xl font-bold">No ex-canaries found</h4>
          </div>
        ) : (
          data?.map((exCanary: Excanary, index: number) => {
            const imageSrc =
              exCanary.gender === 'male' ? '/images/male-avatar.png' : '/images/female-avatar.png'
            return (
              <Link
                href={`/ex-canary/${exCanary.slug}`}
                className="flex sm:flex-col justify-between hover-trigger items-center bg-gray-50 hover:border-black border border-gray-200 sm:w-[220px] sm:h-[345px] h-[120px] w-full m-2 sm:p-4 p-2 rounded-lg shadow-cards "
                key={index}
                prefetch={false}
              >
                <Image
                  src={imageSrc}
                  width={190}
                  height={190}
                  alt={exCanary.gender + ' Ex-Canary'}
                  className="rounded-md sm:w-[190px] sm:h-[190px] w-[100px] h-[100px] sm:mr-0 mr-2"
                />

                <div className="flex flex-col justify-between h-full w-full mt-2">
                  <div className="text-sm line-clamp-4 h-full">{exCanary.excanaryQuote}</div>
                  <div className="flex text-sm font-bold sm:mt-4 ">
                    <span className="mr-2">Read More</span>{' '}
                    <Image
                      className="fill-gray-600"
                      src={'/images/favicons/arrows-right.svg'}
                      alt="chevron-right"
                      width={10}
                      height={10}
                    />
                  </div>
                </div>
              </Link>
            )
          })
        )}
      </div>
    </>
  )
}
